import { useState, useEffect } from "react";
import { useNotificationSnackbar } from "../../../hooks/useNotificationSnackbar";
import { useTPClientService } from "../../../service/tpclient";
import { IOptions } from "../../../service/tpclient/interfaces/IOptions";

export const useOption = (idTree: any): [IOptions[], boolean, () => void] => {
  const { getOptions } = useTPClientService();
  const [rows, setRows] = useState<IOptions[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { onErrorSnackbar } = useNotificationSnackbar();

  const fetch = async () => {
    try {
      if (idTree) {
        setLoading(true);
        const response = await getOptions(idTree);
        if (response.status === 200) {
          setRows(response.data);
          setLoading(false);
        } else {
          onErrorSnackbar(response.data);
          setLoading(false);
        }
      }
    } catch (error: any) {
      setRows([]);
      onErrorSnackbar(error);
      setLoading(false);
    }
  };

  const requestUpdate = () => {
    fetch();
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTree]);

  return [rows, loading, requestUpdate];
};
